(function ($) {
    /**
     * @param $scope The Widget wrapper element as a jQuery element
     * @param $ The jQuery alias
     */

    var WidgetBlockSliderImmobHandler = function ($scope, $) {
        let Swiper = elementorFrontend.utils.swiper;
        document.querySelectorAll(".blocksliderestate .swiper").forEach(function (s) {
            let next = s.parentElement.querySelector(".slide-next");
            let prev = s.parentElement.querySelector(".slide-prev");
            new Swiper(s, {
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: {
                    nextEl: next,
                    prevEl: prev
                }
            });
        });
    }

    var WidgetBlockSliderImageHandler = function ($scope, $) {
        let Swiper = elementorFrontend.utils.swiper;
        document.querySelectorAll(".blocksliderimage .swiper").forEach(function (s) {
            let next = s.parentElement.querySelector(".slide-next");
            let prev = s.parentElement.querySelector(".slide-prev");
            new Swiper(s, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                navigation: {
                    nextEl: next,
                    prevEl: prev
                }
            });
        });
    }

    var WidgetBlockFaqHandler = function ($scope, $) {
        $('.blockfaq-elem .question').click(function() {
            if($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
                $(this).next().slideUp(300);
            }else {
                $(this).parent().addClass('active');
                $(this).next().slideDown(300);
            }
        });
    }

    var WidgetImmobarchHandler = function ($scope, $) {
        $('#reinitform').click(function() {
            $('.estatearchive-filter select').prop('selectedIndex', 0);
            $('.estatearchive-filter input').attr('value', '');
            $('.estatearchive-filter').submit();
        });
    }

    var WidgetBlockCollabHandler = function ($scope, $) {
        $('.blockcollabs-item .btn').click(function() {
            $('#modalcollab .modal-text').html($(this).parent().find('.desccollab').html());
            $('#modalcollab').addClass('open');
            $('html, body').css('overflow', 'hidden');
        });

        $('#modalcollab .modal-close').click(function() {
            $('#modalcollab').removeClass('open');
            $('html, body').removeAttr('style');
        });
    }

    // Make sure you run this code under Elementor.
    $(window).on('elementor/frontend/init', function () {
        elementorFrontend.on('components:init', function () {
            elementorFrontend.hooks.addAction('frontend/element_ready/neolia_immob_list.default', WidgetImmobarchHandler);
            elementorFrontend.hooks.addAction('frontend/element_ready/neolia_immob.default', WidgetBlockSliderImmobHandler);
            elementorFrontend.hooks.addAction('frontend/element_ready/block-sliderimg.default', WidgetBlockSliderImageHandler);
            elementorFrontend.hooks.addAction('frontend/element_ready/block-neolia-faq.default', WidgetBlockFaqHandler);
            elementorFrontend.hooks.addAction('frontend/element_ready/block-collabs.default', WidgetBlockCollabHandler);
        });
    });

})(jQuery);